import React from "react";
import { 
  UserGroupIcon, 
  BriefcaseIcon, 
  BeakerIcon,      // roadmap "lab flask"
  PencilSquareIcon,// create "edit"
  CheckCircleIcon,
  RocketLaunchIcon,
  XMarkIcon 
} from "@heroicons/react/24/outline";
import PeopleSearchBox from "../PeopleSearchBox/PeopleSearchBox";

const CODI_AVATAR_SRC = `${process.env.PUBLIC_URL || ""}/CodiCharacter.png`;

const CodiBadge = () => (
  <div className="flex items-center gap-2">
    <span className="relative h-6 w-6">
      <span
        className="pointer-events-none absolute -inset-1 rounded-full
                   bg-gradient-to-tr from-fuchsia-400/35 via-sky-400/30 to-emerald-400/35"
        aria-hidden
      />
      <img
        src={CODI_AVATAR_SRC}
        alt="Codi"
        className="relative h-6 w-6 object-contain drop-shadow-sm"
      />
    </span>
    <span className="text-xs font-semibold text-gray-700">Codi</span>
  </div>
);

const Spinner = () => (
  <div className="h-5 w-5 rounded-full border-2 border-gray-300 border-t-gray-600 animate-spin" />
);

const CodiStatus = ({ variant = "people", title, subtitle, onDismiss, onSearch, loading }) => {
  // Pick icon by variant
  let Icon;
  if (variant === "people") Icon = UserGroupIcon;
  else if (variant === "projects") Icon = BriefcaseIcon;
  else if (variant === "roadmap") Icon = BeakerIcon;
  else if (variant === "generated") Icon = CheckCircleIcon; // roadmap generated
  else if (variant === "created") Icon = RocketLaunchIcon;  // roadmap created
  else if (variant === "create") Icon = PencilSquareIcon;
  else Icon = BriefcaseIcon; // safe fallback

  return (
    <div className="rounded-2xl border border-gray-200 bg-gradient-to-tr from-sky-50 via-white to-fuchsia-50 p-4 md:p-5 shadow-sm space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <CodiBadge />
          <div className="flex items-center gap-2 text-xs text-gray-600">
            {loading && <Spinner />}
            <span>status</span>
          </div>
        </div>
        <button
          onClick={onDismiss}
          className="h-8 w-8 grid place-items-center rounded-md hover:bg-white/70"
          aria-label="Dismiss"
        >
          <XMarkIcon className="h-5 w-5 text-gray-600" />
        </button>
      </div>

      {/* Content */}
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-white/80 border border-gray-200 grid place-items-center">
          <Icon className="h-6 w-6 text-gray-700" />
        </div>
        <div className="flex-1">
          <div className="font-semibold">{title}</div>
          {subtitle && <div className="text-sm text-gray-600 mt-1">{subtitle}</div>}

          {/* Search box for people mode */}
          {variant === "people" && (
            <div className="mt-3">
              <PeopleSearchBox onSearch={onSearch} />
            </div>
          )}

          {/* Roadmap disclaimer */}
          {variant === "roadmap" && (
            <div className="mt-3 text-xs text-gray-500 italic">
               Your roadmap will be saved and linked to this project.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CodiStatus;
